import React, { useState, useEffect } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useHistory, useParams } from "react-router-dom";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateProfile = () => {
  const history = useHistory();
  const { id } = useParams();

  const [data, setData] = useState({
    // Basic Profile
    profileCreatedFor: "",
    userName: "",
    gender: "male",
    dobDay: "",
    dobMonth: "",
    dobYear: "",
    religion: "",
    kulam: "",
    phone: "",
    email: "",
    // Personality Details
    maritalStatus: "",
    numberOfChildren: "",
    childrenLivingWithMe: "yes",
    physicalStatus: "",
    height: "",
    weight: "",
    bodyType: "",
    complexion: "",
  });

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  const kulamList = [
    "Beerahavaru", "Bodhuvaru", "Bomma jallivaru", "Boothivaru", "Dhasarivaru",
    "Dheiyaluvaru", "Dhogaluvaru", "Dhommaluvaru", "Dhoothaluvaruu", "Eeraluvaru",
    "Engiti aaguluvaru", "Entaluvaru", "Entavaru", "Eramavaru", "Etthulu Thantavaru",
    "Janavaru", "Jallivaru", "Jitthaluvaru", "Kachchavaru", "Kannadivaru",
    "Karavaru", "Kejjaluvaru", "Kodavaru", "Kommuvaru", "Kommuluvaru",
    "Kobaluvaru", "Koolivaru", "Kothaluvaru", "Kotangivaru", "Kuntamukkavaru",
    "Kuntavaru", "Kurukunjaluvaru", "Machchaluvaru", "Maithulavaru", "Mangavaru",
    "Mamidikuntaluvaru", "Mudikiluvaru", "Nallamullavaru", "Nelliyamvaru", "Other",
    "Pachchiluvaru", "Pallavaru", "Pandhivaru", "Pantivaru", "Paravaru",
    "Parvaivaru", "Patamasalavaru", "Payidikutthaluvaru", "Peguluvaru", "Pittavaru",
    "Pannavaru", "Puliputthaluvaru", "Rama jallivaru", "Santhavaru", "Sembootthuluvaru",
    "Settiselvaru", "Soothaluvaru", "Sullivaru", "Sutravaru", "Vejivaru",
  ];

  // Personality Options
  const maritalStatusList = [
    { label: "Never Married", key: "neverMarried" },
    { label: "Divorced", key: "divorced" },
    { label: "Widow / Widower", key: "widow/widower" },
    { label: "Waiting Divorced", key: "waitingDivorce" },
  ];

  const numberOfChildrenList = ["1", "2", "3", "4", "5", "None"];

  const physicalStatusList = [
    { label: "Normal", key: "normal" },
    { label: "Differently Abled", key: "differentlyAbled" },
  ];

  const bodyTypeList = [
    { label: "Average", key: "average" },
    { label: "Athletic", key: "athletic" },
    { label: "Heavy", key: "heavy" },
    { label: "Slim", key: "slim" },
  ];

  const complexionList = [
    { label: "Very Fair", key: "veryFair" },
    { label: "Fair", key: "fair" },
    { label: "Medium", key: "medium" },
    { label: "Brown", key: "brown" },
  ];

  const heightList = [
    "4'6\"", "4'7\"", "4'8\"", "4'9\"", "4'10\"", "4'11\"",
    "5'0\"", "5'1\"", "5'2\"", "5'3\"", "5'4\"", "5'5\"",
    "5'6\"", "5'7\"", "5'8\"", "5'9\"", "5'10\"", "5'11\"",
    "6'0\"", "6'1\"", "6'2\"", "6'3\"", "6'4\"", "6'5\"",
    "6'6\"", "6'7\"", "6'8\"", "6'9\"", "6'10\"", "6'11\"", "7'0\"",
  ];

  const weightList = Array.from({ length: 100 }, function (_, i) {
    return String(41 + i);
  });

  const inputStyle = {
    border: "1.5px solid #757575",
    borderRadius: "12px",
    boxShadow: "none",
    outline: "none",
    fontWeight: "bold",
    color: "#333",
  };

  const labelStyle = {
    color: "#212121",
    fontWeight: "800",
    marginBottom: "6px",
  };

  const handleChange = function (e) {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleChildrenLivingChange = function (value) {
    setData({ ...data, childrenLivingWithMe: value });
  };

  // Convert height string to numeric format
  const getNumericHeight = function (str) {
    if (!str) return "";
    var match = str.match(/(\d+)'(\d+)"/);
    if (match) {
      return match[1] + "." + match[2];
    }
    return str;
  };

  // Convert numeric height to display format
  const getDisplayHeight = function (numStr) {
    if (!numStr) return "";
    var parts = String(numStr).split(".");
    if (parts.length === 2) {
      return parts[0] + "'" + parts[1] + "\"";
    }
    return numStr;
  };

  // Fetch existing data
  useEffect(function () {
    if (!id) return;

    api
      .get("/admin/userProfile/profileView?userId=" + id)
      .then(function (res) {
        var d = res.data && res.data.data ? res.data.data : {};
        console.log("Full API Response:", d);

        var day = "";
        var month = "";
        var year = "";

        var profile = d.profile || {};
        var userDetails = d.userDetails || {};

        console.log("Profile object:", profile);
        console.log("UserDetails object:", userDetails);

        if (profile.dob) {
          var parts = profile.dob.split("-");
          if (parts.length === 3) {
            day = parts[0];
            month = parts[1];
            year = parts[2];
            month = monthNames[Number(month) - 1] || "";
          }
        }

        var updatedData = {
          // Basic Profile
          profileCreatedFor: profile.profileCreatedFor || "",
          userName: profile.userName || "",
          gender: profile.gender || "male",
          dobDay: day || "",
          dobMonth: month || "",
          dobYear: year || "",
          religion: profile.religion || "",
          kulam: profile.kulam || "",
          phone: profile.phone || "",
          email: profile.email || "",
          // Personality Details - all from userDetails
          maritalStatus: userDetails.maritalStatus || "",
          numberOfChildren: userDetails.numberOfChildren ? String(userDetails.numberOfChildren) : "",
          childrenLivingWithMe: userDetails.childrenStayingWithMe || "yes",
          physicalStatus: userDetails.physicalStatus || "",
          height: getDisplayHeight(userDetails.height) || "",
          weight: userDetails.weight ? String(userDetails.weight) : "",
          bodyType: userDetails.bodyType || "",
          complexion: userDetails.complexion || "",
        };

        setData(updatedData);
        console.log("New state will be set to:", updatedData);
      })
      .catch(function (err) {
        console.log("API Error:", err);
        Swal.fire("Error", "Failed to load profile", "error");
      });
  }, [id]);

  const handleSubmit = function (e) {
    e.preventDefault();

    var monthIndex = monthNames.indexOf(data.dobMonth) + 1;
    var finalDob = data.dobDay.padStart(2, "0") + "-" + String(monthIndex).padStart(2, "0") + "-" + data.dobYear;

    // Basic profile payload
    var basicPayload = {
      userId: Number(id),
      profileCreatedFor: data.profileCreatedFor,
      userName: data.userName,
      gender: data.gender,
      dob: finalDob,
      religion: data.religion,
      kulam: data.kulam,
      phone: data.phone,
      email: data.email,
      maritalStatus: data.maritalStatus,
      numberOfChildren: data.numberOfChildren.toLowerCase() === "none" ? 0 : parseInt(data.numberOfChildren) || 0,
      childrenStayingWithMe: data.childrenLivingWithMe,
      physicalStatus: data.physicalStatus,
      height: getNumericHeight(data.height),
      weight: data.weight,
      bodyType: data.bodyType,
      complexion: data.complexion,
    };

    // Personality payload
   
    // Submit both APIs
    Promise.all([
      api.post("/admin/userProfile/basicEdit/", basicPayload),
    ])
      .then(function () {
        Swal.fire("Success", "Profile updated successfully", "success");
        history.goBack();
      })
      .catch(function (error) {
        Swal.fire("Error", error.message || "Something went wrong", "error");
      });
  };

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Profile</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        {/* ==================== BASIC PROFILE ==================== */}
        <h5 style={{ fontWeight: 800, color: "#333", marginBottom: 20, borderBottom: "2px solid #eee", paddingBottom: 10 }}>
          Basic Information
        </h5>

        <FormGroup>
          <Label style={labelStyle}>Profile Created for</Label>
          <Input
            type="select"
            name="profileCreatedFor"
            value={data.profileCreatedFor}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Profile created for</option>
            <option value="myself">Myself</option>
            <option value="son">Son</option>
            <option value="daughter">Daughter</option>
            <option value="brother">Brother</option>
            <option value="sister">Sister</option>
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Name</Label>
          <Input
            type="text"
            name="userName"
            placeholder="Enter your name"
            value={data.userName}
            onChange={handleChange}
            style={inputStyle}
          />
        </FormGroup>

        <Label style={labelStyle}>What is your gender</Label>
        <div className="d-flex mb-3">
          <Button
            type="button"
            onClick={function () { setData({ ...data, gender: "male" }); }}
            style={{
              background: data.gender === "male" ? "green" : "#eee",
              color: data.gender === "male" ? "#fff" : "#292929",
              borderRadius: 10,
              border: "1px solid #7b7b7b",
              marginRight: 10,
              width: "150px",
            }}
          >
            Male
          </Button>
          <Button
            type="button"
            onClick={function () { setData({ ...data, gender: "female" }); }}
            style={{
              background: data.gender === "female" ? "green" : "#eee",
              color: data.gender === "female" ? "#fff" : "#292929",
              borderRadius: 10,
              border: "1px solid #7b7b7b",
              width: "150px",
            }}
          >
            Female
          </Button>
        </div>

        <FormGroup>
          <Label style={labelStyle}>Date of Birth</Label>
          <Row>
            <Col xs="4">
              <Input
                type="select"
                name="dobDay"
                value={data.dobDay}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">Day</option>
                {[...Array(31)].map(function (_, i) {
                  return (
                    <option key={i + 1} value={String(i + 1).padStart(2, "0")}>
                      {i + 1}
                    </option>
                  );
                })}
              </Input>
            </Col>
            <Col xs="4">
              <Input
                type="select"
                name="dobMonth"
                value={data.dobMonth}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">Month</option>
                {monthNames.map(function (m) {
                  return (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  );
                })}
              </Input>
            </Col>
            <Col xs="4">
              <Input
                type="select"
                name="dobYear"
                value={data.dobYear}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">Year</option>
                {Array.from({ length: 50 }, function (_, i) {
                  return new Date().getFullYear() - i;
                }).map(function (y) {
                  return (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  );
                })}
              </Input>
            </Col>
          </Row>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Religion</Label>
          <Input
            type="select"
            name="religion"
            value={data.religion}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select your religion</option>
            <option value="hindu">Hindu</option>
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Kulam</Label>
          <Input
            type="select"
            name="kulam"
            value={data.kulam}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select your Kulam</option>
            {kulamList.map(function (kulam, index) {
              return (
                <option key={index} value={kulam}>
                  {kulam}
                </option>
              );
            })}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Mobile Number</Label>
          <Input
            type="text"
            name="phone"
            placeholder="Enter your Mobile No"
            value={data.phone}
            onChange={function (e) {
              var value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 10) {
                handleChange(e);
              }
            }}
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Email ID</Label>
          <Input
            type="email"
            name="email"
            placeholder="Enter your Email ID"
            value={data.email}
            onChange={handleChange}
            style={inputStyle}
          />
        </FormGroup>

     

        {/* Marital Status */}
        <FormGroup>
          <Label style={labelStyle}>Marital Status</Label>
          <Input
            type="select"
            name="maritalStatus"
            value={data.maritalStatus}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Marital Status</option>
            {maritalStatusList.map(function (item, index) {
              return (
                <option key={index} value={item.key}>
                  {item.label}
                </option>
              );
            })}
          </Input>
        </FormGroup>

        {/* Number of Children - show only if not never married */}
        {data.maritalStatus !== "neverMarried" && data.maritalStatus !== "" && (
          <FormGroup>
            <Label style={labelStyle}>Number of Children</Label>
            <Input
              type="select"
              name="numberOfChildren"
              value={data.numberOfChildren}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="">Select Number of Children</option>
              {numberOfChildrenList.map(function (num) {
                return (
                  <option key={num} value={num}>
                    {num}
                  </option>
                );
              })}
            </Input>
          </FormGroup>
        )}

        {/* Children Staying With Me */}
        {data.maritalStatus !== "neverMarried" && data.maritalStatus !== "" && data.numberOfChildren !== "None" && data.numberOfChildren !== "" && (
          <FormGroup>
            <Label style={labelStyle}>Children Staying With Me</Label>
            <div className="d-flex mb-3">
              {["yes", "no"].map(function (val) {
                return (
                  <Button
                    key={val}
                    type="button"
                    onClick={function () { handleChildrenLivingChange(val); }}
                    style={{
                      background: data.childrenLivingWithMe === val ? "green" : "#eee",
                      color: data.childrenLivingWithMe === val ? "#fff" : "#292929",
                      borderRadius: 10,
                      border: "1px solid #7b7b7b",
                      marginRight: 10,
                      width: "100px",
                    }}
                  >
                    {val.toUpperCase()}
                  </Button>
                );
              })}
            </div>
          </FormGroup>
        )}

        {/* Physical Status */}
        <FormGroup>
          <Label style={labelStyle}>Physical Status</Label>
          <Input
            type="select"
            name="physicalStatus"
            value={data.physicalStatus}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Physical Status</option>
            {physicalStatusList.map(function (status) {
              return (
                <option key={status.key} value={status.key}>
                  {status.label}
                </option>
              );
            })}
          </Input>
        </FormGroup>

        {/* Height */}
        <FormGroup>
          <Label style={labelStyle}>Height</Label>
          <Input
            type="select"
            name="height"
            value={data.height}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Height</option>
            {heightList.map(function (h) {
              return (
                <option key={h} value={h}>
                  {h}
                </option>
              );
            })}
          </Input>
        </FormGroup>

        {/* Weight */}
        <FormGroup>
          <Label style={labelStyle}>Weight (kg)</Label>
          <Input
            type="select"
            name="weight"
            value={data.weight}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Weight</option>
            {weightList.map(function (w) {
              return (
                <option key={w} value={w}>
                  {w} kg
                </option>
              );
            })}
          </Input>
        </FormGroup>

        {/* Body Type */}
        <FormGroup>
          <Label style={labelStyle}>Body Type</Label>
          <Input
            type="select"
            name="bodyType"
            value={data.bodyType}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Body Type</option>
            {bodyTypeList.map(function (b) {
              return (
                <option key={b.key} value={b.key}>
                  {b.label}
                </option>
              );
            })}
          </Input>
        </FormGroup>

        {/* Complexion */}
        <FormGroup>
          <Label style={labelStyle}>Complexion</Label>
          <Input
            type="select"
            name="complexion"
            value={data.complexion}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Complexion</option>
            {complexionList.map(function (c) {
              return (
                <option key={c.key} value={c.key}>
                  {c.label}
                </option>
              );
            })}
          </Input>
        </FormGroup>

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
            marginTop: 20,
          }}
          block
        >
          Save Changes
        </Button>
      </Form>
    </div>
  );
};

export default UpdateProfile;
